/**
 * Normalizes URLs by handling common issues like double slashes
 * @param {string} url - The URL to normalize
 * @returns {string} - The normalized URL
 */
export const normalizeUrl = (url) => {
  if (!url) return url;

  // Handle URLs that start with // by adding https: protocol
  if (url.startsWith("//")) {
    return `https:${url}`;
  }

  return url;
};

/**
 * Processes footer item URLs, handling environment variables and normalization
 * @param {string} itemUrl - The URL from footer item
 * @param {function} t - Translation function
 * @returns {string} - The processed and normalized URL
 */
export const processFooterUrl = (itemUrl, t) => {
  // Return early if no URL provided
  if (!itemUrl) return null;

  let processedUrl;

  // Handle special case for dashboard URL (signup / register)
  if (itemUrl === "dashboard_url") {
    const base = (process.env.NEXT_PUBLIC_DASHBOARD_URL || "https://dashboard.qrhub.io").replace(
      /\/+$/,
      "",
    );
    processedUrl = `${base}/account/create`;
  } else {
    // Only translate if the URL doesn't start with http, https, or /
    if (itemUrl.startsWith("http") || itemUrl.startsWith("/")) {
      processedUrl = itemUrl;
    } else {
      processedUrl = t(itemUrl);
    }
  }

  // Return null if processed URL is invalid
  if (
    !processedUrl ||
    processedUrl === "undefined" ||
    processedUrl === "null"
  ) {
    return null;
  }

  return normalizeUrl(processedUrl);
};
